/* eslint-disable max-lines */
/* eslint-disable max-len */

export default {
  lang: 'fr',
  homeScreen: {
    title: '',
    stayConnected: 'Restez connecté(e)',
    comingSoon: 'Prochainement',
    downloadNow: 'Télécharger maintenant :',
    readMore: 'En savoir plus ',
  },
  glassWidgets: {
    errors: {
      requestFailed: "Une erreur s'est produite. Veuillez réessayer plus tard.",
    },
    programStatus: {
      title: 'Mon Statut',
      loading: 'Chargement…',
      yourRep: 'Votre Représentant',
      myProfile: 'Profil',
      favorites: 'Favoris',
      registeredOn: 'Inscrit le :',
      graduatedOn: 'Diplômé le :',
      totalBadgesEarned: 'Total des Badges Obtenus :',
      lastBookingLogged: 'Dernière Réservation Enregistrée :',
      currentTier: 'Niveau Actuel',
      lastBadgeEarned: 'Dernier Badge Obtenu :',
      currentFocus: 'Objectif Actuel :',
    },
    todaysfocus: {
      title: "Objectif du Jour",
      empty: "Aucun objectif pour aujourd'hui",
      loading: 'Chargement…',
      error: "Une erreur s'est produite",
      slideNavAria: 'Navigation des diapositives',
      slideAria: 'Diapositive',
      carouselAria: 'Objectif du jour',
    },
    welcome: 'Bienvenue !',
    welcomeBack: 'Bon retour, {firstName} !',
    notifications: {
      loading: 'Chargement…',
      empty: 'Aucune notification',
    },
    achievements: {
      title: 'Récompenses et Concours',
      loading: 'Chargement…',
      lastBooking: "Dernière Soumission d'Entrée",
      currentTier: 'Niveau Actuel',
      contestEntries: 'Total des Participations au Concours',
      nightsBooked: 'Nuits Réservées',
      totalRevenue: "Chiffre d'Affaires Total Déclaré",
      noBookingData: 'Aucune donnée de réservation disponible.',
      fileUploadSuccess: 'Le fichier a été téléchargé avec succès.',
      quickSubmit: {
        title: 'Soumission rapide',
        uploading: 'Téléchargement…',
        clear: 'Effacer',
        submit: 'Soumettre',
        submitSuccessSimulated: 'Réservation soumise avec succès',
      },
    },
  },
  profileImageView: {
    currentImage: 'Votre image de profil actuelle :',
    uploadImage: 'Téléchargez votre image de profil :',
    chooseAFile: 'Choisir un fichier…',
    cancel: 'annuler',
    backButton: 'Retour',
    uploadButton: "Télécharger l'image de profil",
    saveButton: 'Enregistrer cette image de profil',
    fileTooLargeTitle: 'Taille de téléchargement dépassée',
    fileTooLargeText: "La taille maximale de l'image à télécharger est de 10 Mo",
  },
  notification: {
    newAndNow: 'Nouveau & Maintenant!',
    alert: 'Alerte',
    message: 'Message',
    badge: 'Nouveau Badge',
    contest: 'Concours',
    'content-update': 'Mise à jour de contenu',
    events: 'Événements',
    other: 'Notification',
    welcome: 'Bienvenue',
  },
  sharing: {
    email: 'E-mail',
    download: 'Télécharger',
    copyURL: 'Copier le lien',
    copied: 'Copié',
    shareSubjectBadge: 'Badge de Spécialiste des États-Unis',
  },
  shareSubjectDiploma: 'Diplôme de Spécialiste des États-Unis',
  loginScreen: {
    version2: {
      accountCreated: 'Un compte a été créé, veuillez vérifier votre e-mail pour terminer le processus.',
      homeTitle: 'Voyons si nous retrouvons votre profil dans le système.',
      homeTitleSub:
        'Saisissez l’adresse e-mail que vous utilisez habituellement pour vous connecter aux programmes de formation.',
      noAccount: 'Aucun compte trouvé ({email}), veuillez essayer avec une autre adresse e-mail ou créer un compte.',
      continueButton: 'Continuer',
      success: 'Votre compte a bien été mis à jour ! Nous allons vous rediriger vers la page d’accueil.',
      successNewAccount:
        'Pour finaliser votre inscription, vous recevrez un e-mail de confirmation destiné à vérifier votre compte.',
      loginButton: 'Connexion',
      matchFound: 'Nous avons trouvé une correspondance. Veuillez saisir votre mot de passe pour continuer.',
      magicLink: 'Connectez-vous via un lien envoyé à votre adresse e-mail :',
      magicLinkButton: 'Demander un lien magique',
      magicLinkTitle: 'Recevez un lien direct envoyé à votre adresse e-mail pour vous connecter instantanément.',
      otherEmailButton: 'Envoyer',
      title:
        'Veuillez prendre quelques instants pour compléter toutes les informations ci-dessous, car elles permettront de renseigner votre profil personnel et vos coordonnées.',
      titleIndustry:
        'Veuillez prendre quelques instants pour compléter toutes les informations ci-dessous, car elles permettront de renseigner votre profil personnel et vos coordonnées.',
      register: 'Créer un compte',
      agent: 'Conseiller en voyages',
      visitor: 'Visiteur professionnel',
      step1: 'Étape 1 : Type d’utilisateur',
      step2: 'Étape 2 : Créer un compte',
      step3: 'Étape 3 : Créer votre profil',
      marketingOptIn:
        'Êtes-vous sûr(e) de ne pas vouloir rester en contact avec l’équipe chargée des voyages (équipe Travel Trade) de ce programme ?',
      optIn: 'Oui, cela m’intéresse',
      optOut: 'Non, cela ne m’intéresse pas',
      step2Sub1: 'Parlez-nous de vous',
      step2Sub2: 'Parlez-nous de votre entreprise',
      privacyHead: 'PRÉFÉRENCES DE COMMUNICATION',
      privacySub:
        'Cochez les cases ci-dessous pour recevoir les communications importantes de l’équipe Travel Trade du fournisseur (mises à jour et annonces concernant les produits, récompenses, offres incitatives, visites de familiarisation (« éductours »), etc.), ainsi que les initiatives Travel Trade de mise en réseau et d’appui aux ventes de TravPRO Mobile.',
      privacy:
        'Nous protégeons votre vie privée et ne vendrons jamais, n’utiliserons jamais à mauvais escient ni ne trahirons votre confiance.',
      store: 'Téléchargez facilement ce programme dans votre boutique d’applications :',
      powered: 'PROPOSÉ PAR',
      toastMessage: {
        forgotSuccess:
          'Nous vous avons envoyé par e-mail le lien de réinitialisation de votre mot de passe ! Nous vous redirigerons vers la page de connexion dans 10 secondes.',
        emailNotExisting: 'L’adresse e-mail que vous avez saisie n’existe pas.',
        magicLinkMessage: 'Veuillez patienter, nous sommes en train de vous connecter.',
        magicLinkError:
          'Nous n’avons pas trouvé votre compte dans notre base de données ; veuillez vous connecter manuellement. Nous vous redirigerons dans 10 secondes.',
        magicLinkError1:
          'Nous n’avons pas trouvé de jeton valide. Veillez vous connecter ou demander un nouveau lien magique. Si le problème persiste, contactez-nous à l’adresse suivante : info@travpromobile.com.',
        magicLinkError2:
          'Nous n’avons pas trouvé votre compte dans notre base de données ; veuillez vous connecter manuellement. Nous vous redirigerons dans 10 secondes.',
        magicLinkSuccess:
          'Consultez votre messagerie à l’adresse {email}. Elle contient un lien magique qui vous permettra de vous connecter.',
        magicLinkErrorWait: 'Patientez 5 minutes entre deux demandes de lien magique.',
        emailNotFoundError:
          'L’adresse e-mail que vous avez saisie ne figure pas dans nos dossiers. Vérifiez qu’il n’y a pas de faute de frappe ou créez un compte.',
      },
      errors: {
        zipCodeNotFound: 'Code postal introuvable, veuillez réessayer',
        zipCodeOnlyNumbers: 'Le code postal ne peut contenir que des chiffres',
        password: 'Saisissez un mot de passe',
        passwordNotMatching: 'Les mots de passe que vous avez saisis ne correspondent pas',
        passwordTooShort: 'Le mot de passe doit comporter au moins 8 caractères',
        emailExists:
          'Cette adresse e-mail existe déjà ou n’est pas valide. Essayez avec une autre adresse e-mail ou connectez-vous à votre compte.',
        fillInAllFields: 'Renseignez tous les champs obligatoires',
        fillInEmail: 'Saisissez votre adresse e-mail.',
        emailNotExisting: 'L’adresse e-mail que vous avez saisie n’existe pas.',
      },
      fields: {
        forgotSubCopy: 'Vous avez oublié votre mot de passe et vous souhaitez le modifier ? ',
        forgotSubCopy2:
          'Vous souhaitez contourner la connexion par mot de passe ? Nous vous enverrons un e-mail contenant un lien magique qui vous permettra de vous connecter automatiquement au programme. ',
        city: 'Ville',
        companyName: 'Nom de la société',
        role: 'Votre poste (sélectionnez une seule réponse)',
        description: 'Quelle proposition décrit le mieux l’activité de votre entreprise ?',
        country: 'Pays',
        password: 'Mot de passe',
        passwordRegister: 'Choisir un mot de passe (8 caractères minimum)',
        passwordConfirm: 'Confirmer le mot de passe',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        agency: 'Nom de votre agence',
        title: 'Votre poste (sélectionnez une seule réponse)',
        company: 'Nom de la société',
        select: 'Sélectionnez une option ci-dessous',
        state: 'État',
        province: 'Province/Région/État',
        zipCode: 'Code postal',
        postalCode: 'Code postal',
        affiliate: 'Quel groupe correspond à votre PRINCIPALE affiliation à une agence ?',
        hostAgency: 'Votre agence d’accueil ?',
        executive: 'Cadre',
        management: 'Direction',
        marketing: 'Marketing',
        sales: 'Ventes',
        coordinator: 'Coordinateur(-trice)',
        opt: "Restez en contact avec l'équipe de Brand USA et recevez les mises à jour du programme de découverte des États-Unis",
        optMarketing: "Restez en contact avec TravPRO pour connaître les programmes d'apprentissage supplémentaires",
        retail: 'Magasin - vente au détail',
        home: 'Agent à domicile',
        independent: 'Sous-traitant indépendant',
        host: 'Agence d’accueil',
        call: 'Centre d’appels ou agence Web',
        other: 'Autre ',
        describes: 'Quelle proposition décrit le mieux votre activité et celle de votre agence ? ',
      },
    },
    title: 'Programme de formation et d’aide à la vente pour les professionnels du voyage',
    welcome: {
      headerTop: 'Bienvenue dans le',
      headerBottom: 'USA Discovery Program',
    },
    sellingPoints: {
      0: 'Découvrez, promouvez et vendez où que vous soyez',
      1: 'Formation multimédia sur tous les appareils',
      2: 'Certificat de réussite',
      3: 'Badges Expérience et Partenaire',
      4: 'Supports promotionnels à partager',
      5: 'Ressources commerciales disponibles 24 h/24',
      6: 'Récompenses de formation',
      7: 'Offres incitatives et offres MegaFam',
    },
    tAndC: {
      agree: 'En continuant, vous acceptez notre ',
      privacyPolicy: 'politique de confidentialité',
      and: ' et nos ',
      termsConditions: 'conditions générales',
    },
    fields: {
      select: 'Sélectionnez une option ci-dessous',
      country: 'Pays',
      agency: 'Agence',
      email: 'E-mail',
      password: 'Mot de passe',
      passwordConfirm: 'Confirmez votre mot de passe',
      firstName: 'Prénom',
      lastName: 'Nom',
      address: 'Adresse',
      postalCode: 'Code postal',
      city: 'Ville',
      agencyName: 'Nom de l’agence',
      stateProvince: 'État/Province',
      required: 'Obligatoire',
      invalidEmail: 'Adresse e-mail non valide',
      opt: 'Restez en contact ! Oui, je souhaite recevoir les communications de Brand USA qui me permettront de rester au courant des actualités, des événements, des offres incitatives, des éductours et bien plus encore !',
      forgot:
        'Mot de passe oublié ? Cliquez sur le bouton ci-dessous, et nous vous enverrons un e-mail pour réinitialiser votre mot de passe.',
    },
    forgot: 'Réinitialiser le mot de passe',
    noAgent: {
      noAgentButton: 'Je ne suis pas un agent',
      title: 'Nous vous remercions de l’intérêt que vous portez au USA Discovery Program.',
      messageWeb:
        'Le contenu de ce site est exclusivement destiné aux professionnels du voyage. \n Pour en savoir plus sur Brand USA, rendez-vous sur : ',
      messageMobile:
        'Certains contenus de cette application sont exclusivement destinés aux professionnels du voyage, mais vous pouvez découvrir un aperçu de ce que cette application propose en cliquant sur « Continuer ».',
      continue: 'Continuer',
      visitWebsite: 'Consulter le site Web',
    },
    newUser: 'Nouvel utilisateur',
    register: 'S’inscrire',
    registered: 'Cette adresse e-mail est déjà enregistrée',
  },
  welcomeScreen: {
    title: 'Bienvenue dans le USA Discovery Program',
    helloUser: 'Bonjour {{name}}',
    hello: 'Bonjour,',
    fromAgency: 'de {{agency}}',
    notUser: 'Vous n’êtes pas {{name}} ?',
    startTraining: 'Commencer à apprendre',
    continueTraining: 'Continuer à apprendre',
    graduated: 'Félicitations !',
    downloader: {
      stop: 'arrêter',
      init: 'Initialisation...',
      lastUpdate: 'Dernière mise à jour : ',
    },
  },
  trainingScreens: {
    comingSoon: 'Prochainement : {title}',
    categoryLockMinimum: 'Débloquez au moins {number} formations incluses pour accéder à cette catégorie.',
    allUnlocked: 'Vous avez débloqué tous les chapitres !',
    completedBase: 'Félicitations, vous êtes officiellement un(e) Spécialiste des États-Unis !',
    certificate: 'Certificat',
    chapter: 'Chapitre',
    chapterComplete: 'Chapitre terminé !',
    choose: 'Choisissez une réponse',
    confirm: 'Confirmez votre réponse',
    continue: 'Continuer',
    courseComplete: 'Formation terminée !',
    durationInMinutes: '{number} minutes',
    endReached: 'Vous avez atteint la fin',
    essential: 'Les fondamentaux',
    essentialSub:
      'Terminez ces chapitres essentiels pour obtenir votre diplôme et accéder aux spécialisations ci-dessous.',
    message: '{count} message',
    messagePlural: '{count} messages',
    percentageComplete: '{number} % terminés',
    restart: 'Consulter',
    review: 'Consulter',
    retainEnd:
      'Utilisez la barre supérieure pour parcourir ce chapitre ou cliquez sur le bouton de retour pour revenir à la vue d’ensemble.',
    retry: 'Réessayer',
    skip: 'Retour >',
    viewAllTitle: 'Conseil de formation',
    badge: 'Télécharger le badge',
    viewAll:
      'Avant de passer à la page suivante, prenez le temps de consulter l’ensemble du contenu présent sur cette page, y compris les icônes, car celles-ci donnent des informations supplémentaires pour vous aider à devenir expert(e).',
    start: 'Démarrer',
    status: 'Statut actuel :',
    trouble:
      'Il semble que vous rencontriez des problèmes. Nous vous invitons à relire le contenu de la ou des pages précédentes et à réessayer.',
    unlockDefault: 'Accédez à ce chapitre après avoir terminé le précédent.',
    unlock: 'Pour accéder à ce chapitre, terminez le chapitre de la formation.',
    unlockSubtitle: 'Accédez à d’autres chapitres après avoir terminé les chapitres de la formation.',
    unlockFoundation: 'Accédez à ces chapitres après avoir terminé Les fondamentaux.',
    watchListenRead: 'Regarder, Écouter et En savoir plus',
    completed: 'Terminé',
  },
  trainingExtraScreens: {
    subtitle: 'LES EXPÉRIENCES',
    error: 'Oups. Une erreur est survenue',
    uncompletedTitle: 'EXPÉRIENCES NON TERMINÉES DE {partner}',
    completedTitle: 'EXPÉRIENCES TERMINÉES DE {partner}',
    noAvailableBadges: 'Aucun badge n’est disponible pour le moment.',
    interimScore: 'Terminez',
    interimScoreEnd: 'plus de chapitres pour obtenir votre badge.',
    badgesComplete: 'Félicitations ! Vous avez obtenu le badge :',
  },
  newTrainingFlow: {
    partnerModules: 'SPÉCIALISATIONS DES PARTENAIRES',
    finishGold: 'Apprenez à connaître nos partenaires et terminez ces chapitres pour obtenir des badges.',
  },
  points: {
    complete: {
      chapter: 'Chapitre terminé !',
      'intro-chapter': 'Chapitre d’introduction terminé !',
      'sub-app': 'Sous-application terminée !',
      rewards: 'Récompenses terminées !',
    },
    completed: '{completed} badges obtenus',
  },
  nav: {
    home: 'Accueil',
    train: 'Se former',
    learn: 'Se former',
    retain: 'Retenir',
    promote: 'Promouvoir',
    sell: 'Vendre',
    info: 'Infos',
    rewards: 'Récompenses',
    media: 'Médias',
    favorites: 'Favoris',
    contact: 'Gardons le contact',
    diploma: 'Diplôme',
    accountSettings: 'Paramètres du compte',
    messages: 'Messages',
    search: 'Rechercher',
    showcases: 'Vitrines',
  },
  contentHeaders: {
    subapps: 'SPÉCIALISATIONS DES PARTENAIRES',
    maintrainings: 'Agences',
    subtrainings: 'Les expériences',
    itineraries: 'ITINÉRAIRES',
  },
  pageDescriptions: {
    train: 'Formez, interagissez et développez votre expertise.',
    retain: 'Consolidez vos connaissances pour affiner votre expertise grâce à ce contenu simple d’utilisation.',
    promote: 'Partagez ces éléments pour susciter l’intérêt et nouez le dialogue avec des clients et des prospects.',
    sell: 'Répondez aux questions des clients et interagissez avec Brand USA.',
    favorites: 'Votre contenu préféré.',
    search: 'Examinez l’ensemble du contenu',
    subapps: 'Apprenez à connaître nos partenaires et terminez ces chapitres pour obtenir des badges.',
    subtrainings: 'Renforcez votre expertise et obtenez un badge pour chaque rubrique ci-dessous.',
    itineraries: 'Lisez ces courts chapitres sur les road trips les plus populaires et gagnez un badge pour chacun d\'entre eux.',
  },
  general: {
    website: 'https://www.thebrandusa.com/',
    forgot: 'Mot de passe oublié ?',
    next: 'Suiv.',
    yes: 'Oui',
    no: 'Non',
    previous: 'Précédent',
    submit: 'Envoyer',
    register: 'S’inscrire',
    back: 'Retour',
    close: 'Fermer',
    page: 'Page',
    search: 'Rechercher',
    logIn: 'Se connecter',
    logOut: 'Se déconnecter',
    viewItem: 'Consulter {type}',
    imageNotFound: 'Image introuvable',
    noResultsFor: 'Aucun résultat trouvé pour : {{query}}',
    noFavorites: 'Vous n’avez pas encore de favoris.',
    noMessages: 'Vous n’avez pas encore reçu de message.',
    resultsFor: 'Résultats pour : {{query}}',
    showAll: 'Tout afficher',
    connectionError: 'Erreur de connexion',
    alreadyExists: 'Existe déjà',
    pageNotFound: '404 - Page introuvable !',
    oops: 'Dommage !',
    overview: 'Revenir à la vue d’ensemble',
    complete: 'Continuer',
    courseComplete: 'Chapitre terminé !',
    chapterComplete: 'Chapitre terminé !',
    message: 'Message ({count})',
    messagePlural: 'Messages ({count})',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Mise en page',
    web: 'Site Web',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Faites pivoter les cadrans pour les placer sur la réponse',
    fitb: 'Complétez le ou les champs vides',
    flip: 'Modifiez le numéro pour qu’il corresponde à la réponse',
    multipleChoice: 'Sélectionnez la ou les bonnes réponses',
    slider: 'Sélectionnez la bonne réponse à l’aide du curseur',
    map: 'Répondez à la question en cliquant sur l’emplacement approprié sur la carte',
    dropdown: 'Choisir…',
    true: 'Vrai',
    false: 'Faux',
  },
  reportCard: {
    download: 'Télécharger',
    email: 'E-mail',
    print: 'Imprimer',
  },
  cookies: {
    consent: 'D’ACCORD',
    optout: 'Se désabonner',
    settings: 'Paramètres de confidentialité',
    message:
      'Vous n’avez rien indiqué sur vos préférences en matière de protection des données ! Ce n’est pas grave, mais nous souhaitons vous offrir la meilleure expérience d’utilisation de l’Assistant de vente.',
    disabled: 'Il semble que vous ayez désactivé les cookies.',
    use: '{{appName}} nécessite l’utilisation de cookies pour vous offrir la meilleure expérience possible.',
    details: 'À quoi servent les cookies ?',
    enable: 'Découvrez comment activer vos cookies {{here}}.',
    here: 'ici',
  },
  notLoggedIn: {
    super: 'Vous n’êtes pas connecté(e)',
    title: 'Vous devez être connecté(e) pour consulter ce contenu',
    guest: 'Invité(e)',
  },
  demo: {
    message:
      'Ce site Web est une démonstration du produit final. Il est en cours de développement et est susceptible d’évoluer.',
    consent: 'Compris !',
  },
  share: {
    header: 'Partagez cette ressource sur vos réseaux sociaux préférés !',
    download: 'Télécharger',
    email: 'E-mail',
  },
  breadCrumbs: {
    page: 'Page',
  },
  storeButtons: {
    title: 'Téléchargez l’application sur votre appareil mobile',
  },
  onMobile: {
    header: 'Il semble que vous tentiez d’accéder à l’application {appName} depuis un appareil mobile',
    body: 'Pour télécharger ce programme, rendez-vous dans votre boutique d’applications et recherchez {appName} ou cliquez sur l’un des boutons ci-dessous',
    benefits: {
      1: 'Découvrez, promouvez et vendez où que vous soyez',
      2: 'Formation multimédia sur tous les appareils',
      3: 'Certificat de réussite',
      4: 'Badges Expérience et Partenaire',
      5: 'Supports promotionnels à partager',
      6: 'Ressources commerciales disponibles 24 h/24',
      7: 'Récompenses de formation',
      header: 'Cela vous permettra de :',
    },
  },
  custom: {
    splitUsers: 'Je suis...',
    brandAmbassador: 'Ambassadeur/Ambassadrice de marque',
    travelPro: 'Professionnel(le) du voyage',
  },
  rewards: {
    menu: {
      home: 'Accueil\nRécompenses',
      achievements: 'Réalisations\nFormation',
      bookings: 'incentives\nBadges',
      form: 'Soumettre\nRéservations',
    },
    rewards: 'Récompenses',
    title: 'Bienvenue dans le Centre des récompenses et des réalisations',
    subheader: 'Suivez et partagez les offres incitatives et les réalisations liées aux formations',
    button: 'Soumettez votre réservation',
    viewAllBookings: 'Réservations',
    viewDashboard: 'Tableau de bord des points',
    viewRewards: 'Vue d’ensemble',
    overview: {
      valid: '*Les réservations saisies ne sont valides qu’une fois le voyage du client terminé.',
    },
    home: {
      entries: 'Entrées actuelles',
      trainingAchievements: 'RÉALISATIONS LIÉES AUX FORMATIONS',
      trainingAchievementsText:
        'Suivez vos progrès de formation, vos certifications et votre statut de récompenses (Bronze, Argent, Or, Platine) sur cette page. Vous pourrez également télécharger et partager votre diplôme de Spécialiste des États-Unis, ainsi que tous les badges que vous avez obtenus dans les sections Expériences et Spécialisations des partenaires.',
      bookingContests: 'TABLEAU DE BORD DES OFFRES INCITATIVES',
      bookingContestsText:
        'Suivez et gérez facilement les programmes d’offres incitatives en cours sur le Tableau de bord des offres incitatives. ',
      submitBooking: 'SOUMETTRE DES RÉSERVATIONS',
      submitBookingText:
        'C’est ici que vous soumettrez les réservations pour les inclure dans les offres incitatives à la réservation.',
      currentContest: 'OFFRES INCITATIVES EN COURS',
      noContests: 'Il n’y a actuellement aucune offre incitative liée aux badges.',
      ContestEndDate: 'Fin de l’offre incitative :',
      ContestDetails: 'Détails de l’offre incitative',
      ContestSeeProgram: 'Reportez-vous aux',
      ContestTerms: 'conditions générales du programme',
      ContestForDetails: 'pour plus de détails.',
      ContestPartnerLink: 'Accéder à Partenaire',
      ContestLink: 'Accéder à Lien',
    },
    bookingsView: {
      title: 'Réservations',
      infoMessage:
        "Trier à l'aide des boutons ci-dessus et cliquer sur n'importe quel enregistrement pour gérer les détails de la soumission. Toutes les entrées en attente seront vérifiées dans les 72 heures",
    },
    leaderboardScreen: {
      prizes: 'Prix',
      tAndC: 'Des conditions générales s’appliquent*',
    },
    dashboardView: {
      title: 'Tableau de bord des offres incitatives',
      subtitle: 'Suivez les activités relatives à vos offres incitatives ici.',
      badge: 'Offres incitatives liées aux badges',
      activity: 'Offres incitatives à la réservation',
      manage: 'Gérer les réservations',
      manageSub:
        'Suivez les réservations en cours ci-dessous, ou consultez les réservations archivées en utilisant le menu déroulant.',
      noBadgeIncentives: 'Il n’y a actuellement aucune offre incitative liée aux badges.',
      noBookings: 'Il n’y a aucun enregistrement à afficher.',
      state: {
        approvedEntries: 'Entrées Approuvées',
        pendingEntries: 'Entrées en Attente',
        declinedEntries: 'Entrées Refusées',
        viewAll: 'Voir Tout',
      },
      currentYear: 'Année en Cours',
      archivedBookings: 'Réservations Archivées',
    },
    bookingForm: {
      title: 'Formulaire de crédit de réservation aux États-Unis',
      subTitle: 'Saisissez votre réservation :',
      required: '* Indique un champ obligatoire',
      email: 'Adresse e-mail du conseiller/de la conseillère',
      agentFirstName: 'Prénom du conseiller/de la conseillère',
      agentLastName: 'Nom du conseiller/de la conseillère',
      company: 'Nom de l’agence/de la société',
      iata: 'N° IATA/CLIA',
      stateProvince: 'État/Province',
      postalCode: 'Code postal',
      country: 'Pays',
      city: 'Ville',
      birthday: 'Anniversaire',
      type: 'Type de voyage du client',
      source: 'Source de la réservation',
      tourOperator: 'Voyagiste',
      firstName: 'Prénom du client',
      lastName: 'Nom de famille du client',
      confirmNumber: 'Numéro de confirmation de la réservation/Numéro PNR',
      ticketNumber: 'Numéro de billet.',
      file: 'Téléchargement de la preuve RezSnap™ ',
      arrivalDate: 'Date d’arrivée dans l’établissement',
      departureDate: 'Date de départ de l’établissement',
      brand: 'Marque réservée',
      lengthOfStay: 'Durée du séjour',
      cost: 'Coût total de la réservation',
      rooms: 'Nombre de chambres',
      airline: 'Compagnie aérienne/transporteur (code à 2 chiffres)',
      gateway: 'Provenance (code aéroport à 3 lettres)',
      destination: 'Destination/île (code aéroport à 3 lettres)',
      disclaimer: '* Champs obligatoires',
      button: 'Soumettez votre réservation',
      sub: 'Vos informations',
      sub2: 'Informations sur la réservation',
      travelDepartureDate: 'Date de départ',
      travelReturnDate: 'Date de retour',
      flightNumber: 'Numéro du vol à destination des États-Unis',
      numberOfTravelers: 'Nombre de voyageurs dans le groupe',
      edit: 'Modifier vos informations',
      fileUploaded: 'Le fichier a bien été téléchargé',
      select: 'Veuillez sélectionner une option ci-dessous',
      drag: 'Glissez-déposez un fichier ici, ou cliquez pour sélectionner un fichier.',
      fileType:
        '(Un seul fichier, les fichiers .jpeg, .png et .pdf seront acceptés. La taille maximale du fichier est de 100 MB.)',
      maxSize: 'La taille maximale de fichier est de 100 Mo',
    },
    TermsAndConditions: {
      title: 'Conditions générales',
      subTitle: 'Récompenses trimestrielles de Spécialiste',
      body1:
        'Toute publication doit être assortie d’un document de preuve de vente au solde nul correspondant à chaque réservation que vous avez publiée. Les lauréats seront sélectionnés sur étude de l’ensemble des documents de preuve de vente vérifiés correspondant à chaque réservation indiquée. Pour être éligibles, les publications doivent respecter l’intégralité des règles du USA Discovery Program.',
      body2:
        'Pour être éligible, vous devez résider aux États-Unis ou travailler chez Brand USA, et avoir atteint au moins l’âge de la majorité dans l’État, la province ou le territoire où vous résidez. Les employés de voyagistes NE sont PAS éligibles aux tirages au sort et NE seront PAS pris en compte pour des prix supplémentaires. Les résidents de la province canadienne du Québec NE sont PAS éligibles aux tirages au sort et NE seront PAS pris en compte pour des prix supplémentaires.',
      body3:
        'La remise de récompenses peut nécessiter une preuve d’accréditation en tant que conseiller en voyages en agence/à domicile. Les récompenses disponibles sont susceptibles de changer au cours du programme.',
      body4: 'Confidentialité et utilisation des données personnelles',
      body5:
        'L’Agent participant (i) accorde à la Personne chargée d’accorder une récompense le droit d’utiliser son nom, sa ville, son État, sa province, son code postal, sa confirmation de majorité, son numéro de téléphone et son adresse e-mail, y compris, mais sans s’y limiter, aux fins de contacter et d’annoncer le nom des Lauréats et la remise des récompenses ; (ii) accorde au Lauréat le droit d’utiliser ses données personnelles à des fins publicitaires et promotionnelles en lien avec les récompenses, sur tous les médias existants à ce jour ou créés ultérieurement, sans compensation supplémentaire, à moins que la loi ne l’interdise ; et (iii) reconnaît que les Lauréats peuvent divulguer leurs données personnelles à des agents et prestataires de services tiers dans le cadre de l’une des activités énumérées aux points (i) et (ii) ci-dessus.',
      button: 'Revenir à l’accueil',
    },
    thankYouPage: {
      thanks: 'Merci',
      congrats: 'Félicitations, ',
      body: 'votre réservation a bien été reçue et envoyée au superviseur de la campagne pour vérification.',
      link: 'Veuillez noter que pour faire partie des gagnants, vous devez avoir terminé la partie Les fondamentaux du USA Discovery Program',
    },
  },
  facts: {
    title: 'Saviez-vous?',
  },
  badgeView: {
    other: 'Partenaires régionaux',
    unlock: 'Commencez à compléter des éléments de formation pour recevoir des badges',
    title: 'Réalisations de Formation',
    subtitle:
      'Bienvenue sur votre tableau de bord des Réalisations, où vous pouvez voir, suivre et télécharger votre diplôme et vos badges de spécialisation.',
    viewBadge: 'Voir Statut',
    badgeDisplayTitle: 'STATUT DES RÉCOMPENSES MÉTALLIQUES',
    badgeAchievement:
      'Vous avez atteint le Statut {rank}! Cliquez sur l’icône à droite pour voir et partager votre statut.',
    badgesCompleteTitle: 'Vos badges de spécialisation',
    badgesCompleteSubtitle: 'Cliquez sur les icônes pour voir, sauvegarder et partager vos badges.',
    badgesIncompleteSubtitle: 'Gagnez plus de badges en complétant ces chapitres.',
    bronze: 'Bronze',
    silver: 'Argent',
    gold: 'Or',
    platinum: 'Platine',
    diploma: 'Diplôme',
    experiencesBadgesSectionTitle: 'Les badges Expériences',
    itinerariesBadgesSectionTitle: 'Badges d’itinéraires',
    partnerSpecializationBadgesSectionTitle: 'Badges de spécialisation partenaire',
    complete: 'COMPLÈTE',
  },
  missing: {
    discover: 'Découvrir',
    pacific: 'Pacifique',
    west: 'Ouest',
    southwest: 'Sud-Ouest',
    midwest: 'Midwest',
    south: 'Sud-Est',
    northeast: 'Nord-Est',
    territories: 'Territoires',
    shoppingAttractions: 'Shopping & Attractions',
    gettingAround: 'Se Déplacer',
    regionalPartners: 'Partenaires Régionaux',
    greatOutdoors: 'Grands Espaces',
    winterSports: "Sports d'Hiver",
    coastalEscapes: 'Évasions Côtières',
    flyDrive: 'Fly-Drive',
    foodDrink: 'Nourriture & Boissons',
    luxury: 'Luxe',
    musicCultureHeritage: 'Musique, Culture & Patrimoine',
    nationalParks: 'Parcs Nationaux',
    regionMap: 'Carte de la Région',
    videos: 'Vidéos',
    images: 'Images',
    incentives: 'Offres Incitatives',
    southeast: 'Sud-Est',
  },
  searchModal: {
    search: 'Rechercher',
    subtitle: 'Parcourir tout le contenu',
    pages: 'USA Discovery Program',
    partnerPages: 'Programmes Partenaires',
    salesCompanion: 'Articles du Compagnon de Vente',
    exhibitionTiles: 'Vitrines Partenaires',
    noResults: 'Aucun résultat trouvé...',
  },
};
